import { monthsList } from '../app/app.const';
import * as moment from 'moment-timezone';

export function formatDate(dateObject: number) {

  let date = new Date(dateObject);
  let day = date.getDate();
  let monthIndex = date.getMonth();
  let year = date.getFullYear();

  return day + ' ' + monthsList[monthIndex].name + ' ' + year;
}

export function dateFromString(formatted: string): number {
  return Date.parse(formatted);
}

export function dateFromTimeString(formatted: string): number {
  return Date.parse('01/01/2018 ' + formatted);
}

export function getLocalMoment(date: Date): moment.Moment {
  return moment(date).tz(moment.tz.guess());
}

export function getLocalDate(date: Date): Date {
  return getLocalMoment(date).toDate();
}

export function calculateAge(birthDate: Date) {
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();

  if (today.getMonth() < birthDate.getMonth()) {
    age -= 1;
  }

  if (today.getMonth() === birthDate.getMonth()) {
    if (today.getDate() < birthDate.getDate()) {
      age -= 1;
    }
  }

  return age;
}



// WEBPACK FOOTER //
// ./src/util/date-util.tsx